import WHITE_LOGO from "@/assets/branding/logo-white.svg";
import classNames from "classnames";
import { Link } from "react-router-dom";

const FooterBranding = ({ className }: { className?: string }) => {
  return (
    <div
      className={classNames(
        "footer-branding flex items-center justify-center max-w-28 w-28 py-6 px-1 mx-1",
        className
      )}
    >
      <Link to="/" className="flex items-center justify-center">
        <img src={WHITE_LOGO} alt="Aalyana" />
      </Link>
    </div>
  );
};

export default FooterBranding;
